import * as React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Typography } from '@mui/material';
import { Loading } from './';

export const loadingPage = (isAuthenticating: boolean = true) => (
  <main>
    <Box className="loading-page-spinner" sx={{ ...flex.colCenter, gap: '50px' }}>
      <Loading />
      {isAuthenticating && (
        <Typography variant="h4" sx={{ color: theme => theme.palette.colors.neutrals[500] }}>
          Authenticating...
        </Typography>
      )}
    </Box>
  </main>
);
